export default "__VITE_ASSET__2e835723__"